export default function PageHero({
  badge,
  title,
  titleAccent,
  subtitle,
}: {
  badge: string;
  title: string;
  titleAccent?: string;
  subtitle: string;
}) {
  return (
    <section style={{ background: 'linear-gradient(180deg, #FFF0F5 0%, #FFFBF8 100%)', padding: '48px 0 40px', borderBottom: '1px solid #F0C8D8' }}>
      <div className="container-wide">
        <p style={{ fontSize: 11, fontWeight: 800, letterSpacing: '0.16em', textTransform: 'uppercase', color: '#C2185B', marginBottom: 12 }}>{badge}</p>
        <h1 style={{ fontSize: 'clamp(2rem, 5vw, 3.2rem)', fontWeight: 900, letterSpacing: '-0.03em', margin: '0 0 12px', color: '#1A0A10' }}>
          {title} {titleAccent ? <span className="gradient-text">{titleAccent}</span> : null}
        </h1>
        <p style={{ fontSize: 16, color: '#6B3A52', maxWidth: 680, margin: 0, lineHeight: 1.65 }}>{subtitle}</p>
      </div>
    </section>
  );
}
